import { render, staticRenderFns } from "./t-page-form-field-customized.vue?vue&type=template&id=d0f3ce54&scoped=true&"
import script from "./t-page-form-field-customized.vue?vue&type=script&lang=js&"
export * from "./t-page-form-field-customized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f3ce54",
  null
  
)

export default component.exports